import SaveGraphsController from './dialogs/save-graphs/controller';

const SaveGraphsTemplate = require('./dialogs/save-graphs/template.html');

export default class NotificationsController {
    /** @ngInject */
    constructor(EventEmitter, DialogService) {
        this.eventEmiter = EventEmitter;
        this.DialogService = DialogService;
    }

    save() {
        this.DialogService.show({
            controller: SaveGraphsController,
            controllerAs: '$ctrl',
            template: SaveGraphsTemplate,
            parent: document.body,
            openFrom: 'top',
            closeTo: 'top',
            clickOutsideToClose: true,
            escapeToClose: true,
            fullscreen: true
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/graphs/graphs.controller.js